export default __webpack_public_path__ + "static/media/MYSQL.21fb711f.svg";